var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.data,{key:_vm.data,tag:"component",attrs:{"callback":_vm.setComponent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }